import capitalize from 'lodash/capitalize';

const colors: { [key: string]: string[] } = {
    blue : ['#001D5A', '#00256D', '#002D80', '#003594', '#1D4BA0', '#355FAC', '#4D73B7', '#6587C2'],
    teal : ['#005E75', '#00718C', '#0085A5', '#009ABE', '#39A4C5', '#56AECB', '#6EB9D2', '#85C3D9'],
    green: ['#055D51', '#077063', '#0B8475', '#0E9987', '#3CA392', '#57AD9E', '#6FB7A9', '#85C2B5'],
    yellow  : ['#936E00', '#B08500', '#CE9C00', '#EDB400', '#EFBC3F', '#F1C45D', '#F3CC75', '#F5D38B'],
    purple  : ['#443C6B', '#534981', '#625798', '#7265AF', '#7F74B8', '#8C83C0', '#9992C8', '#A7A1D0'],
    orange : ['#873A23', '#A2472B', '#BD5435', '#DA623E', '#E07353', '#E58366', '#EA937A', '#EEA38C'],
    gray : ['#131313', '#333333', '#515151', '#646464', '#8B8B8B', '#ACACAC', '#D1D1D1', '#E3E3E3', '#EEEEEE', '#F7F7F7'],
};

let startsWith = 80;
export const colorOptions = Object.keys(colors)
    .map((key) => {
        if (key === 'gray') {
            startsWith = 100;
        }
        return colors[key].map((color, index) =>
            ({ label: `${capitalize(key)} ${startsWith - index * 10}`, value: color })
        );
    })
    .reduce((total, colorOption) => [...total, ...colorOption], []);
